import { Link } from "@/lib/router-compat";
import { Check } from "lucide-react";
import { NO_COMMISSION_LINE, PROMISE_PATH } from "@/data/disclosuresCopy";

const CHIPS = ["You choose every professional", "Your employer never sees your details"];

/** Homepage "Who pays us" section — employer-only compensation story. */
export default function WhoPaysUs() {
  return (
    <section aria-labelledby="who-pays-us" className="border-t border-border bg-card py-14 sm:py-16">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
        <p className="text-xs font-bold uppercase tracking-wide text-primary">Who pays us</p>
        <h2 id="who-pays-us" className="mt-2 text-3xl font-bold text-foreground sm:text-4xl">
          {NO_COMMISSION_LINE}.
        </h2>
        <p className="mt-2 text-lg font-semibold text-primary">Paid by employers. Never by your lender.</p>
        <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-muted-foreground">
          Home Approach is free for you. Employers who offer it as a benefit are how we're paid, and that's our entire
          business model. We don't take commissions, referral fees, or payments from real estate agents, lenders, or
          title companies. Not to list them, not to rank them, not when you close. The only thing we're built to do is
          help you buy the right home, on your terms.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-2">
          {CHIPS.map((c) => (
            <li key={c} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-sm font-medium text-foreground">
              <Check className="h-4 w-4 text-primary" aria-hidden /> {c}
            </li>
          ))}
        </ul>
        <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm font-semibold">
          <Link to={PROMISE_PATH} className="text-primary hover:underline">Read our promise</Link>
          <Link to="/how-we-make-money" className="text-primary hover:underline">How we make money</Link>
        </div>
      </div>
    </section>
  );
}
